import { PROS_ZOR_TABS_SEQUENCE } from '../../constants/tabs';
import { getRecommendations } from '../getRecommendations';
import { transformItemsToTabs } from './transformItemsToTabs';
import { getOrderedProsTabs } from './getOrderedProsTabs';

export const getProsTabs = async ({ prosZonesInfo, brand, userStatus, deviceType }) => {
  // 1. Filter out zones that don't have enough info
  const validZones = ['category', 'brand', 'sale']
    .map((type) => ({ type, info: prosZonesInfo[type] }))
    .filter((zone) => zone.info?.context && zone.info?.maxRecs);

  if (validZones.length < 2) return [];

  // 2. Fetch data in parallel
  const requests = validZones.map((zone) =>
    getRecommendations({
      zone: zone.info.context,
      maxRecsCount: zone.info.maxRecs,
      brand,
      deviceType,
    }),
  );
  const responses = await Promise.allSettled(requests);

  // 3. Attach data to zones and filter out empty responses
  const populatedZones = validZones
    .map((zone, index) => {
      const response = responses[index];
      const data = response.status === 'fulfilled' ? response.value?.data : null;
      return { ...zone, treatmentId: data?.treatmentId || '', recommendedItems: data?.recommendedItems || [] };
    })
    .filter((zone) => zone.recommendedItems.length > 0);

  if (populatedZones.length < 2) return [];

  // 4. Transform items to tabs using a shared Set to enforce global uniqueness
  const globalUniqueIds = new Set();

  const tabsByType = {};
  for (const zone of populatedZones) {
    const tabs = transformItemsToTabs({
      items: zone.recommendedItems,
      type: zone.type,
      zone: zone.info.context,
      maxRecs: zone.info.maxRecs,
      treatmentId: zone.treatmentId,
      brand,
      userStatus,
      globalUniqueIds,
    });

    if (tabs.length > 0) {
      tabsByType[zone.type] = tabs;
    }
  }

  // 5. Final check: do we still have at least 2 valid zones after transformation?
  if (Object.keys(tabsByType).length < 2) return [];

  // 6. Return the perfectly ordered sequence
  return getOrderedProsTabs(tabsByType, PROS_ZOR_TABS_SEQUENCE[brand][userStatus]);
};
